import { NumberOperator, Accepts, Types } from "@citychallenge/common";
import { Subject, Observable } from "rxjs";
import * as ops from "rxjs/operators";

interface FilterOpts {
  operator?: NumberOperator;
}
type FilterFn = (
  subject: Subject<any>,
  key: string,
  target?: number | string | null,
  options?: FilterOpts
) => Observable<any>;

export const filterMap: { [key: string]: FilterFn } = {
  /* Number filter */
  [Accepts.Number]: function (
    subject: Subject<any>,
    key: string,
    target: Types["Number"],
    options: {
      operator: NumberOperator;
    }
  ) {
    switch (options.operator) {
      case ">":
        return subject.pipe(
          ops.filter((value: any) => {
            return value[key] > target;
          })
        );
      case "<":
        return subject.pipe(
          ops.filter((value: any) => {
            return value[key] < target;
          })
        );
      case "==":
        return subject.pipe(
          ops.filter((value: any) => {
            return value[key] == target;
          })
        );
      case "!=":
        return subject.pipe(
          ops.filter((value: any) => {
            return value[key] != target;
          })
        );
      default:
        return subject;
    }
  },

  [Accepts.XRHotspot]: function (
    subject: Subject<any>,
    key: string,
    target?: string
  ) {
    return subject.pipe(
      ops.filter((value: any) => {
        if (!target) return true;

        const hotspot: Types["XRHotspot"] = value[key];
        return hotspot.id == target;
      })
    );
  },
  [Accepts.IdAndLabel]: function (
    subject: Subject<any>,
    key: string,
    target?: string
  ) {
    return subject.pipe(
      ops.filter((value: any) => {
        if (!target) return true;

        const marker: Types["IdAndLabel"] = value[key];
        return marker.id == target;
      })
    );
  },
  /* Geomarker filter */
  [Accepts.GeoMarker]: function (
    subject: Subject<any>,
    key: string,
    target?: string
  ) {
    return subject.pipe(
      ops.filter((value: any) => {
        if (!target) return true;

        const marker: Types["GeoMarker"] = value[key];
        return marker.id == target;
      })
    );
  },
};
